import { render, staticRenderFns } from "./TicketCancel.vue?vue&type=template&id=d567470e&scoped=true&"
import script from "./TicketCancel.vue?vue&type=script&lang=js&"
export * from "./TicketCancel.vue?vue&type=script&lang=js&"
import style0 from "./TicketCancel.vue?vue&type=style&index=0&id=d567470e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d567470e",
  null
  
)

export default component.exports